import { Table, TableProps } from 'antd'
import { observer } from 'mobx-react-lite'
import { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'
import { Cameras } from 'sections/LKSection/modules/OrderModule/types'
import { Flex, Modal, Text } from 'components/uiKit'
import { getSharedKey } from 'utils/helpers/i18n/getKeys'
import { useResize } from 'utils/hooks/useResize'

type DataType = {
  key: string
  name: string
  limitDays: number
  status: number
  archAvailability: boolean
}

type CCTVModalProps = {
  cameras: Cameras[]
  isModalOpen: boolean
  setIsModalOpen: (value: boolean) => void
}

const getKey = (key: string) => `${OrderKeys.activateOrderPage}.${key}`

export const CCTVModal = observer(({ cameras, isModalOpen, setIsModalOpen }: CCTVModalProps) => {
  const { isMobile } = useResize()
  const { t } = useTranslation()

  const style: CSSProperties = { wordWrap: 'break-word', wordBreak: 'keep-all', fontSize: isMobile ? 11 : 16 }

  const columns: TableProps<DataType>['columns'] = [
    {
      title: <Text style={style}>{t(getKey('Название камеры'))}</Text>,
      dataIndex: 'name',
      key: 'name',
      render: (value) => <Text style={style}>{value}</Text>,
    },
    {
      title: <Text style={style}>{t(getKey('Глубина архива'))}</Text>,
      dataIndex: 'limitDays',
      key: 'limitDays',
      render: (value) => <Text style={style}>{value}</Text>,
    },
    {
      title: <Text style={style}>{t(getSharedKey('status'))}</Text>,
      dataIndex: 'status',
      key: 'status',
      render: (value) => <Text style={style}>{value ? t(getSharedKey('online')) : t(getSharedKey('offline'))}</Text>,
    },
    {
      title: <Text style={style}>{t(getKey('Доступность архива'))}</Text>,
      dataIndex: 'archAvailability',
      key: 'archAvailability',
      render: (value) => <Text style={style}>{value ? t(getSharedKey('yes')) : t(getSharedKey('no'))}</Text>,
    },
  ]

  return (
    <Modal
      title={`${t(getSharedKey('Внимание'))}!`}
      open={isModalOpen}
      onOk={() => setIsModalOpen(false)}
      onCancel={() => setIsModalOpen(false)}
      cancelButtonProps={{ style: { display: 'none' } }}
      centered
      width={700}
    >
      <Flex vertical gap={16}>
        <Text>{t(getKey('Проверьте состояние камер'))}</Text>

        <Table<DataType>
          columns={columns}
          dataSource={cameras.map((camera) => ({ ...camera, key: camera.idCamera }))}
          pagination={false}
          size="large"
        />
      </Flex>
    </Modal>
  )
})
